'use client'

import SectionBadge from '@/components/ui/section-badge'
import { Accordion, AccordionItem, AccordionButton, AccordionPanel } from '@/components/animate-ui/headless/accordion'
import { cn } from '@/lib/utils'
import styles from './faq.module.css'

export interface FAQItem { question: string; answer: string }
interface FAQSectionProps {
  title?: string
  subtitle?: string
  badge?: string
  showBadge?: boolean
  items: FAQItem[]
  className?: string
  mode?: 'light' | 'dark'
}
export default function FAQSection({ title = 'Questions, answered.', subtitle, badge = 'FAQ', showBadge = true, items, className }: FAQSectionProps) {
  return (
    <div id="faq" className={cn(styles.faq, className)}>
      <div className={styles.heading}>
        {showBadge && <SectionBadge>{badge}</SectionBadge>}
        <h2>{title}</h2>
        {subtitle && <p>{subtitle}</p>}
      </div>
      <Accordion className={styles.rows}>
        {items.map((faq, index) => (
          <AccordionItem key={index} className={styles.row}>
            <AccordionButton className={styles.question}><span>{faq.question}</span></AccordionButton>
            <AccordionPanel className={styles.answer}>{faq.answer}</AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  )
}
